export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6198.9ac5b5fa.jpg";